<template>
  <Layout class='trade-info'>
    <div>
      <RadioGroup :style="{boxShadow: 'unset', textShadow: 'unset'}" v-model="selected" buttonStyle="solid" @change='changeViewType'>
        <RadioButton :value="ViewType.Yesterday">昨日</RadioButton>
        <RadioButton :value="ViewType.SevenDay">近7天</RadioButton>
      </RadioGroup>
      <label class='time-label'>时间：</label>
      <DatePicker @change="changeSDate"/> - <DatePicker @change="changeEDate"/>
      <Button :style="{boxShadow: 'unset', textShadow: 'unset', borderRadius: '2px'}" type='primary' class='trade-bt' @click="searchTradeData">查询</Button>
    </div>
    <div v-if="show" class='trade-item-warp'>
      <div class='trade-item' v-for="(item, index) in stData" :key='index'>
        <img :src='$viewImage(item.image, 60, 60)'>
        <div class='trade-item-content'>
          <p class='trade-item-title'>{{item.title}}</p>
          <p class='trade-item-value'>{{viewData[item.link]}}</p>
        </div>
      </div>
    </div>
    <div v-if="!show">
      <ECharts class='chart-line' :options="options" :init-options="{ renderer: 'svg' }" autoresize></ECharts>
    </div>
  </Layout>
</template>
<script>
import { Layout, Row, Col, Radio , DatePicker, Button, message } from 'ant-design-vue'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/axis'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/graphic'
import ECharts from 'vue-echarts'
import moment from 'moment'
import { Line } from 'kw-bweb-chart-pc'
// import KWUtil from 'kw-bweb-util'
export default {
  data() {
    return {
      options: {},
      ViewType:{ Yesterday: 1, SevenDay: 2},
      viewData: {},
      viewDataList: {},
      tradeData: [],
      sDate: '',
      eDate: '',
      selected: 1,
      show: true
    }
  },
  props: {
    stData: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.buildParams(this.ViewType.Yesterday)
  },
  methods: {
    changeViewType(e) {
      // console.log(e)
      const type = e.target.value
      this.show = true
      this.buildParams(type)
    },
    buildParams(type) {
      let startDate, endDate
      if (type === this.ViewType.Yesterday) {
        startDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
        endDate = startDate
      } else {
        startDate = moment().subtract(7, 'day').format('YYYY-MM-DD')
        endDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      }
      this.getTradeData(startDate, endDate)
    },
    changeSDate(date, dateString) {
      this.sDate = dateString
    },
    changeEDate(date, dateString) {
      this.eDate = dateString
    },
    checkDateRange(start, end) {
      if (start && end) {
        const startMoment = moment(start)
        const endMoment = moment(end)
        const days = endMoment.diff(startMoment, 'days')
        // console.log(days)
        if (days > 6) {
          return true
        }
      }
      return false
    },
    async getTradeData(start, end) {
      const json = await this.$store.dispatch('dfwHome/getTradeInfo', {
        bid: this.$cookie.get('buzzId'),
        sDate: start,
        eDate: end
      })
      this.viewData = json
    },
    async searchTradeData() {
      if (this.sDate && this.eDate) {
        const flag = this.checkDateRange(this.sDate, this.eDate)
        if (flag) {
          return message.info('开始日期和结束日期需要相距7天内')
        }
        const json = await this.$store.dispatch('dfwHome/batchGetTradeInfo', {
          bid: this.$cookie.get('buzzId'),
          sDate: this.sDate,
          eDate: this.eDate
        })
        this.selected = 0
        this.show = false
        this.viewDataList = json
        // console.log(this.viewDataList)
        this.buildOption()
      } else {
        message.info('请选择开始和结束日期，且开始日期和结束日期相距7天内')
      }
    },
    buildOption() {
      const keys = ['orderDetails', 'visitDetails']
      const keysObj = {
        orderDetails: {
          text: '订单量（单）',
          title: '订单量（单）'
        },
        visitDetails: {
          text: '访问量（人）',
          title: '访问量（人）'
        }
      }
      let max = []
      const legend = []
      const yNames = []
      let xData = []
      const ydata = keys.map((key, index) => {
        const keyObj = keysObj[key]
        legend.push(keyObj.text)
        yNames.push(keyObj.title)
        const data = this.viewDataList[key] || []
        xData = data.map(y => {return { value:y.time }})
        const yydata = data.map(y => y.num)
        max[index] = Math.ceil(Math.max(...yydata)/10) * 10
        return {
          name: keyObj.text,
          data: data.map(y => {return { value:y.num }}),
          yAxisIndex: index
        }
      })
      const option = Line.getOptions({
        title: '',
          yShow: true,
          grid: {
            // top: '5%',
            left: '5%',
            // bottom: '15%',
          },
          color: ['#ff3a00', '#2b8eff'],
          legend: {
            itemWidth: 16,
            itemHeight: 16,
            textStyle: {
              color: `#333333`,
              fontSize: 14,
            },
            data: legend
          },
          xData,
          yData: ydata,
          yName: yNames[0],
          smooth: true,
          max: max[0],
          needArea: true,
          yAxisSplitLine: {
            lineStyle: {
              color: ['#EEEEEE'],
            }
          },
          needDoubleY: true,
          showSymbol: true,
          symbolSize: 8,
          max2: max[1],
          y2Show: true,
          y2Name: yNames[1],
      })
      // console.log(option)
      this.options = option
    },
  },
  components: {
    Layout,
    [Row.name]: Row,
    [Col.name]: Col,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    DatePicker,
    ECharts,
    Button
  }
}
</script>
<style lang="scss">
.trade-info {
  .ant-radio-button-wrapper:first-child{
    border-radius: 2px 0 0 2px;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0 2px 2px 0;
  }
  .ant-input{
    border-radius: 2px;
  }
}
</style>
<style lang="scss" scoped>
.trade-info{
  max-width: 1055px;
  background: #fff;
  display: flex;
  align-items: center;

  .trade-bt{
    margin-left: 20px;
    margin-top: 1px;
  }
  .time-label{
    padding-left: 40px;
  }
  .trade-item-warp{
    display: flex;
  }
  .trade-item{
    margin-top: 30px;
    width: 340px;
    height: 120px;
    padding: 30px;
    display: flex;
    align-items: center;
    border: 1px solid $color-e2;

    &:first-child{
      border-right: 0;
    }

    img{
      width: 60px;
      height: 60px;
    }
    .trade-item-content{
      flex: 1;
      padding-left: 15px;

      .trade-item-title{
        font-size: 14px;
        color: $title-color-333;
      }
      .trade-item-value{
        font-size: 24px;
        color: $title-color-333;
      }
      .trade-item-content{
        font-size: 24px;
        color: $title-color-333;
      }
    }
  }
  .chart-line{
    width: 1055px;
  }
}
</style>
